<template>
    <form @submit.prevent="submit">
        <div class="modal-card" style="width: auto">
        
            <header class="modal-card-head">
                <p class="modal-card-title">Clone Role</p>
            </header>

            <section class="modal-card-body">
        
                <b-field label="Role Name">
                    <b-input type="text" v-model="data.name" placeholder="Enter Role Name"></b-input>
                </b-field>
                
                <!-- <b-field label="Role Type">
                    <b-input type="text" v-model="data.type" placeholder="Enter Role Type"></b-input>
                </b-field> -->

            </section>
            
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Close</button>

                <button class="button is-primary" :disabled="loading">Clone</button>
            </footer>
        
        </div>
    </form>
</template>
<script>
import { RoleService } from "@/services/role.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";

export default {
    props: {
        cloneRole: {
            type: Object,
            default: () => {}
        }
    },
    data: () => ({
        roleService: RoleService,
        data: { name: null, type: null },
        loading: false
    }),
    methods: {
        async submit() {
            try {
                this.loading = true;
                const response = await this.roleService.create(this.data);
                const role = JsonDenormalizer.denormalize(response);
                if (this.cloneRole.permissions.length > 0) {
                    const updatedRole = await this.syncPermissions(role);
                }

                this.loading = false;

                this.$emit("cloned");
                this.$parent.close();
            } catch (err) {
                this.loading = false;
            }
        },
        async syncPermissions(role) {
            const data = {
                permission_ids: this.cloneRole.permissions.map(a => a.id)
            };
            const response = await this.roleService.syncPermissions(
                role.id,
                data
            );
            const updatedRole = JsonDenormalizer.denormalize(response);
            return updatedRole;
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Roles/partials/cloneRoleModal.vue